// TODO: come up with some better approach to determine type input
export enum SpecialFieldLabel {
    Birth = "Birth",
    Place = "Place",
}
